import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'vila-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor() { }

  @Input() public message: string;

  ngOnInit(): void {
  }

}
